export enum ApiError {
  unknown,
}

export enum CartApiError {
  noBasket = "noBasket",
  unknown = "unknown",
}
